import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const savedDarkMode = localStorage.getItem("darkMode");
if (savedDarkMode === "true") {
  document.documentElement.classList.add("dark");
} else if (savedDarkMode === "false") {
  document.documentElement.classList.remove("dark");
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
